import { Fixture } from '@cds/betting-offer';
import { EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';

export class BetBuilderViewModel {
    fixture?: Fixture;
    eventOptionGroups: EventOptionGroup[];
    availableMarketGroups: { [key: string]: number } | undefined;
}
